import { useAuthQuery } from '../auth/hooks/useAuthQuery';
import { CAR_SEAT_AUTO_SELECT_MAX_AGE, MIN_CAR_SEAT_AGE } from '../riders/constants/riderServices';

export const useAgeRestrictionPolicy = () => {
  const { userSettings } = useAuthQuery();

  const getAgeRestrictionPolicyMessage = (age) => {
    if (age < MIN_CAR_SEAT_AGE) {
      return userSettings?.ageRestrictionPolicy || '';
    }
    if (age >= MIN_CAR_SEAT_AGE && age <= CAR_SEAT_AUTO_SELECT_MAX_AGE) {
      return `Riders between the ages of ${MIN_CAR_SEAT_AGE}-${CAR_SEAT_AUTO_SELECT_MAX_AGE} years old automatically have Car Seat selected. If a car seat is not required, you can deselect it.`;
    }

    return '';
  };

  return {
    getAgeRestrictionPolicyMessage,
  };
};
